import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';

@Injectable({
  providedIn: 'root'
})
export class NotifyerrortoadminsListenerService {

  @Output() notifyErrorToAdminsListener: EventEmitter<any> = new EventEmitter();

  constructor() {
    this.notifyErrorToAdminsListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        });
  }
}
